(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-scroll-fixed-navbar"] = factory();
	else
		root["vue-scroll-fixed-navbar"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 